(() => {
    const contactButton = document.querySelector('.contact-pop');
    if (!contactButton) return;
    
    const debounce = (func, delay) => {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }


    const getStoreParameter = () => {
        const hostName = window.location.host;
        const countrys = [
            {
                name: 'US',
                url: 'www.renogy.com',
                country_name: 'United States',
                rgc: 'US'
            },
            {
                name: 'CA',
                url: 'ca.renogy.com',
                country_name: 'Canada',
                rgc: 'CA'
            },
            {
                name: 'AU',
                url: 'au.renogy.com',
                country_name: 'Australia',
                rgc: 'AU'
            },
            {
                name: 'GB',
                url: 'uk.renogy.com',
                country_name: 'United Kingdom',
                rgc: 'UK'
            },
            {
                name: 'DE',
                url: 'de.renogy.com',
                country_name: 'Germany',
                rgc: 'DE'
            },
            {
                name: 'JP',
                url: 'jp.renogy.jp',
                country_name: 'Japan',
                rgc: 'JP'
            },
            {
                name: 'FR',
                url: 'fr.renogy.com',
                country_name: 'France',
                rgc: 'FR'
            },
            {
                name: 'NL',
                url: 'nl.renogy.com',
                country_name: 'Netherlands',
                rgc: 'NL'
            },
            {
                name: 'EU',
                url: 'eu.renogy.com',
                country_name: 'European Union',
                rgc: 'EU'
            },
            {
                name: 'Sandbox',
                url: 'shopify-uk.renogy.cn',
                country_name: 'United Kingdom',
                rgc: 'Sandbox'
            },
            {
                name: 'Sandbox',
                url: '127.0.0.1:9292',
                country_name: 'United States',
                rgc: 'Sandbox'
            }
        ];

        // 查找匹配的域名
        const matchedCountry = countrys.find(country => country.url === hostName);
        
        if (matchedCountry) {
            const userEmail = document.querySelector('[data-user-email]').getAttribute('data-user-email');
            if (userEmail) {
                return `?store=${matchedCountry.name}&email=${userEmail}`;
            }
            return `?store=${matchedCountry.name}`;
        }
        
        // 如果没有匹配到，不添加任何参数
        return '';
    }

    // 添加CSS样式
    const style = document.createElement('style');
    style.textContent = `
        .ai-iframe-container {
            position: fixed;
            bottom: 10px;
            right: 64px;
            width: 640px;
            max-width: 100%;
            max-height: 100%;
            height: 88vh;
            z-index: 99999;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
            background: #fff;
            transform: scale(0.3) translate(100px, 100px);
            transform-origin: bottom right;
            opacity: 0;
            visibility: hidden;
            transition: transform 0.25s linear, opacity 0.25s linear, visibility 0.25s linear;
        }
        #zc__sdk__container {
            width: 640px !important;
            height: 88vh !important;
        }
        
        .ai-iframe-container.ai-show {
            transform: scale(1) translate(0, 0);
            opacity: 1;
            visibility: visible;
        }
        

        
        .ai-iframe-header {
            background: linear-gradient(to right, rgb(11, 53, 135), rgb(11, 53, 135));
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 15px;
            color: white;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            font-size: 14px;
            font-weight: 500;
            position: relative;
            overflow: hidden;
        }
        
        
        
        .ai-iframe-title {
            flex: 1;
        }
        
        .ai-iframe-controls {
            display: flex;
            gap: 12px;
            align-items: center;
        }
        
        .ai-iframe-btn {
            width: 32px;
            height: 32px;
            border: none;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            color: white;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: bold;
            transition: all 0.2s linear;
            transform: scale(1);
        }
        .ai-iframe-btn.chatbot{
            display: flex; 
            align-items: center; 
            gap: 8px;
            cursor: pointer; 
            width: auto;    
            border-radius: 200px;
            border:1px solid rgba(255, 255, 255, 0.6);
            height:40px;
            background: rgba(36,74,147,1)
                linear-gradient(
                104deg,
                rgba(36,74,147,1) 60%,
                rgba(11, 53, 135,1) 60%,
                rgba(11, 53, 135,1) 100%
                )
                100% 100% no-repeat;
            background-size:300% 100% !important;
            transition:all 0.3s linear;
            padding:4px 10px 4px 4px;
            font-weight:500;
        }
        .ai-iframe-btn.chatbot img{
            width:32px;
            height:32px;
        }
        .ai-iframe-btn:not['.chatbot']:hover {
            background: rgba(255, 255, 255, 0.6);
            transform: scale(1.05);
        }
        .ai-iframe-btn.chatbot:hover{
            background-position:0 100% !important;
            transform: scale(1.05);
        }

        .ai-iframe-btn:active {
            transform: scale(0.98);
        }
        
        .ai-iframe-btn.minimize {
            font-size: 16px;
            line-height: 1;
        }
        
        
        .ai-iframe-content {
            height: calc(100% - 56px);
            position: relative;
        }
        
        .ai-iframe-content iframe {
            width: 100%;
            height: 100%;
            border: none;
            display: block;
            opacity: 0;
            transition: opacity 0.3s linear;
        }
        
        .ai-iframe-content iframe.loaded {
            opacity: 1;
        }
        
        .ai-loading {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f8f9fa;
            z-index: 10;
            transition: opacity 0.3s linear;
        }
        
        .ai-loading.hidden {
            opacity: 0;
            pointer-events: none;
        }
        
        .ai-spinner {
            width: 40px;
            height: 40px;
            border: 3px solid #e3e3e3;
            border-top: 3px solid rgb(11, 53, 135);
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        #zc__sdk__container {
            right:64px !important;
        }    
        
        @media (max-width: 768px) {
            .ai-iframe-header{
                height: 40px;
            }
            .ai-iframe-content {
                height: calc(100% - 40px);
            }
            .ai-iframe-container {
                width: 100vw;
                height: 100vh;
                bottom: 0;
                left: 0;
                border-radius: 0;
            }
                 #zc__sdk__container {
                    width: 100% !important;
                    height: 100% !important;
                    right: 0 !important;
                 }
            .ai-iframe-btn {
                width: 24px;
                height: 24px;
            }
            .ai-iframe-btn svg {
                width: 20px;
                height: 20px;
            }
            .ai-iframe-controls {
                gap: 8px;
            }
            .ai-iframe-btn.chatbot {
                padding:2px 10px 2px 2px;
                height:28px;
            }
            .ai-iframe-btn.chatbot img{
                width:24px;
                height:24px;
            }
            .ai-iframe-btn.chatbot svg:last-child{
                width:12px;
                height:12px;
            }
        }
        

    `;
    document.head.appendChild(style);

    const createIframeAi = () => {
        const container = document.createElement('div');
        container.className = 'ai-iframe-container ai-show';
        const ai_user_icon = window.aiUserIcon
        container.innerHTML = `
            <div class="ai-iframe-header">
                <div class="ai-iframe-title"></div>
                <div class="ai-iframe-controls">
                    <div id="liveChatBtn" class="ai-iframe-btn chatbot" style="">
                        <img src="${ai_user_icon}" />
                        <span style="display: flex; gap: 2px;align-items: center;">
                            Chat with an Agent
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M4.07157 2.14258L7.80749 5.8785C7.87444 5.94545 7.87444 6.05399 7.80749 6.12094L4.07157 9.85686" stroke="white" stroke-width="0.857143" stroke-linecap="round"/>
                            </svg>
                        </span>


                    </div>
                    <button class="ai-iframe-btn minimize" title="hide" style="background: none;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19.7143 8.14265L12.2424 15.6145C12.1086 15.7484 11.8915 15.7484 11.7576 15.6145L4.28572 8.14265" stroke="white" stroke-width="1.71429" stroke-linecap="round"/>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="ai-iframe-content">
                <div class="ai-loading">
                    <div class="ai-spinner"></div>
                </div>
              <iframe src="https://ai.renogy.com${getStoreParameter()}"></iframe>
            </div>
        `;
        
        document.body.appendChild(container);
        
        // 添加事件监听器
        const minimizeBtn = container.querySelector('.minimize');
        const iframe = container.querySelector('iframe');
        const loading = container.querySelector('.ai-loading');
        
        // iframe加载完成后隐藏loading
        iframe.addEventListener('load', () => {
            setTimeout(() => {
                loading.classList.add('hidden');
                setTimeout(() => {
                    iframe.classList.add('loaded');
                }, 100); // 先隐藏loading，再显示iframe
            }, 300); // 延迟300ms让用户看到loading效果
        });
        
        // 如果iframe加载失败，也要隐藏loading
        iframe.addEventListener('error', () => {
            loading.innerHTML = `
                <div style="color: #ff4757; font-size: 24px;">⚠️</div>
            `;
        });
        
        minimizeBtn.addEventListener('click', () => {
            container.classList.remove('ai-show');
        });

        document.getElementById('liveChatBtn').addEventListener('click', () => {
            container.classList.remove('ai-show');
            document.querySelector('.zc__sdk__sys__btn').click();
            console.log('live chat2')
        })
        
        return container;
    }

    contactButton.addEventListener('click', debounce(() => {
        const existingContainer = document.querySelector('.ai-iframe-container');
        
        if (existingContainer) {
            if (existingContainer.classList.contains('ai-show')) {
                existingContainer.classList.remove('ai-show');
            } else {
                existingContainer.classList.add('ai-show');
            }
        } else {
            createIframeAi();
        }
    }, 200))
})()